import { TmrBaseResource } from 'stylewhere/api'

export class WorkOrderRows extends TmrBaseResource {
  static endpoint = 'api/v1/workOrderRows' //tracking
}
